// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "PricingSection-module--wrapper--JitDz";
export var title = "PricingSection-module--title--aa3ZE";
export var paymentsMethodsInfoWrapper = "PricingSection-module--paymentsMethodsInfoWrapper--FUMwR";
export var paymentsMethodsList = "PricingSection-module--paymentsMethodsList--GBsMa";
export var paymentsMethodsAdditionalDescription = "PricingSection-module--paymentsMethodsAdditionalDescription--IQFDe";
export var ratesListWrapper = "PricingSection-module--ratesListWrapper--W6Qj+";
export var item = "PricingSection-module--item--9maiO";
export var sectionDecorator = "PricingSection-module--sectionDecorator--NZK1j";
export var ratesNotFoundText = "PricingSection-module--ratesNotFoundText--CRyCv";